import React from 'react';
import { ModuleCarousel } from '../../ModuleCarousel';
export const HeroNarrativeCarouselModule = React.forwardRef(({ supertext = '', headline = '', image, layout = 'imageLeft', showBurst = false, colors, carouselSlides = [], onShowSlide = () => { }, shouldAnimate, }, _ref) => {
    const coverSlide = {
        contentType: 'heroNarrativeCover',
        supertext,
        headline,
        image,
        layout,
        showBurst,
        colors,
    };
    const slides = [coverSlide, ...carouselSlides].filter(Boolean);
    return (React.createElement(ModuleCarousel, { contentType: "heroNarrativeCarousel", shouldAnimate: shouldAnimate, slides: slides, onShowSlide: onShowSlide }));
});
